import React from 'react';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'ai-translate';

const aiTranslationFeatures = ({ packages }) => ({
  costPerCharacter: {
    key: 'ai-translation-cost-per-char',
    label: 'aiTranslateText',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
});

export default aiTranslationFeatures;
